/* Mobile accordions for the product-description section (description /
   product details / key features / size chart), per owner's request -
   collapsible, closed by default on mobile. Desktop keeps every panel
   open via CSS (llm-product-description.css force-shows them), so this
   toggle is only meaningful below that breakpoint; harmless above it. */
(function () {
  document.querySelectorAll('.llm-pd-accordion__header').forEach(function (header) {
    header.addEventListener('click', function () {
      var acc = header.closest('.llm-pd-accordion');
      if (!acc) return;
      var isOpen = acc.classList.toggle('is-open');
      header.setAttribute('aria-expanded', String(isOpen));
    });
  });

  /* "Size Chart" link beside the option/SKU line (llm-option-popup.js, or main-product.liquid for
     products with no options) - owner 2026-10-24. Desktop: scroll to the full-width chart below the
     description grid. Mobile: that block is display:none and the chart lives in the "Size Chart"
     dropdown instead, so open the dropdown and scroll to it - the same move llm-rating-badge.js makes
     for Reviews. Window scroll computed by hand, not scrollIntoView, for the reason given there. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.llm-size-chart-link');
    if (!link) return;
    var target = document.querySelector('.llm-product-size-chart');
    var acc = document.querySelector('.llm-pd-accordion--size-chart');
    if (acc && acc.offsetParent !== null) {
      acc.classList.add('is-open');
      var header = acc.querySelector('.llm-pd-accordion__header');
      if (header) header.setAttribute('aria-expanded', 'true');
      target = acc;
    }
    if (!target || target.offsetParent === null) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.scrollY - 90; // clear the sticky header
    var start = window.scrollY;
    window.scrollTo({ top: top, behavior: 'instant' });
    // A smooth scroll can silently not start (measured 2026-10-24: right after the dropdown opens,
    // the window stayed at 0). If it hasn't moved, jump - landing on the chart beats a dead link.
    setTimeout(function () {
      if (Math.abs(window.scrollY - start) < 2 && Math.abs(top - start) > 2) window.scrollTo(0, top);
    }, 700);
  });
})();
